<script>
    import Computation from '@js/modules/computation';

    import Icon from '@js/components/themes/Icon.svelte';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    const {
        ride,
        isHighlighted,
        isFaded
    } = $props();
</script>

<a class="flex flex-col md:flex-row items-center md:items-stretch md:max-w-xl my-4 first:mt-1 bg-white border border-gray-200 rounded-lg md:outline-2 md:outline-primary-600 shadow-sm transition-all duration-200"
   class:outline={isHighlighted}
   class:opacity-[0.45]={isFaded}
   href={ride.link}>
    <picture class="w-full max-h-32 md:max-h-28 md:w-auto basis-28">
        <source media={`(min-width: ${window.settings.small_screen}px)`}
                type="image/webp"
                srcset={ride.defaultPicture.medium ? ride.defaultPicture.medium.webp : ride.defaultPicture.webp}/>
        <source media={`(min-width: ${window.settings.small_screen}px)`}
                srcset={ride.defaultPicture.medium ? ride.defaultPicture.medium.jpg : ride.defaultPicture.jpg}/>

        <source srcset={ride.defaultPicture.mini ? ride.defaultPicture.mini.webp : ride.defaultPicture.webp}
                type="image/webp"/>
        <img class="object-cover w-full md:w-28 md:max-w-initial h-full max-h-32 rounded-t-lg md:rounded-none md:rounded-s-lg"
             srcset={ride.defaultPicture.mini ? ride.defaultPicture.mini.jpg : ride.defaultPicture.jpg}
             src={ride.defaultPicture.mini ? ride.defaultPicture.mini.jpg : ride.defaultPicture.jpg}
             alt={ride.name}/>
    </picture>

    <div class="flex flex-col justify-between w-11/12 md:w-auto p-2 leading-normal overflow-hidden">
        <div class="inline-block w-fit px-2 py-1 text-primary-900 text-xs font-semibold bg-primary-100 rounded-full tracking-wide">
            <Icon class="inline-flex h-4 w-4 me-1"
                  icon={RIDE_TYPE_ICON[ride.rideType]}/>
            {ride.rideTypeTranslated}
        </div>

        <h4 class="mt-2 mb-0 text-lg font-bold tracking-tight text-gray-900 text-ellipsis overflow-hidden whitespace-nowrap">
            {ride.name}
        </h4>

        <div class="flex items-center justify-start mb-2 text-sm text-primary font-semibold tracking-wider whitespace-nowrap">
            <div class="bullet-separator">
                <span>
                    {@html Computation.formatDistance(ride.distance, {
                        smartUnit: true,
                        kUnit: false,
                        decimalLimit: 2
                    })
                        .replace('.', ',')
                        .replace(/(?!,)(\D+)/g, '<span class="text-sm text-gray-600 font-normal">$1</span>')}
                </span>
            </div>

            {#if !!ride.formattedDuration}
                <div class="bullet-separator">
                    {@html ride.formattedDuration.replace(/(?!,)(\D+)/g, '<span class="text-sm text-gray-600 font-normal">$1</span>')}
                </div>
            {/if}

            {#if ride.level !== 'level_undefined'}
                <div class="bullet-separator">
                    <span>
                        {ride.levelTranslated}
                    </span>
                </div>
            {/if}

            <!--{-->
            <!--    !!hasSpeed &&-->
            <!--    <div className="ride-mini-card-stat">-->
            <!--        {Computation.formatSpeed(ride.speed)}-->
            <!--    </div>-->
            <!--}-->
        </div>
    </div>
</a>
